function ExpandLess({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.39999 15.0387L6.34616 13.9849L12 8.33105L17.6538 13.9849L16.6 15.0387L12 10.4387L7.39999 15.0387Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ExpandLess;
